import React from "react";
import CardsPage from "components/common/cards/CardsPage";

const EmployeeCards: React.FC = () => <CardsPage mine />;

export default EmployeeCards;
